<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventTypeStyle } from '@/lib/eventTypes'

const props = defineProps({
  /**
   * Event type (see racing_events.md).
   * Expected values: best_lap | best_lap_points | best_session | best_session_points | stages |
   * monthly_season
   */
  type: {
    type: String,
    required: true,
  },
})

const { t, te } = useI18n()

/** Colour and icon of the type: the mapping is shared with the trophies (see lib/eventTypes). */
const style = computed(() => eventTypeStyle(props.type))

/** Falls back to the raw type when the translation is missing, instead of showing the i18n key. */
const label = computed(() => (te(`eventTypes.${props.type}`) ? t(`eventTypes.${props.type}`) : props.type))
</script>

<template>
  <v-chip
    :color="style.color"
    :prepend-icon="style.icon"
    size="small"
    variant="flat"
    label
  >
    {{ label }}
  </v-chip>
</template>
